import React, { Component, useState, useEffect } from "react";
import { v4 as uuid } from "uuid";
import { usePopperTooltip } from 'react-popper-tooltip';
import 'react-popper-tooltip/dist/styles.css';

export function FieldHolder({...props}) {
    let hasError = false;
    let errorTxt = null;
    let uid = uuid();
    let required = false;
    let label = props?.label;
const {
    getArrowProps,
    getTooltipProps,
    setTooltipRef,
    setTriggerRef,
    visible,
  } = usePopperTooltip();
  
    if(label && label.indexOf('*') >= 0) {
      label = label.replace('*', '').trim();
      required = true;
    }
console.debug("props.errorprops.errorprops.errorprops.errorprops.error",props.error);
    if(props.error && props.error.data && props.error.data.data) {
        if( props.error.data.data[props.id] ) {
            hasError = true;
            errorTxt =     props.error.data.data[props.id].join(", ");
        }
    } else if (props.error && props.error[props.id]) {
        hasError = true;
        errorTxt =     props.error[props.id]; //.join(", ");

    }
    const [er, setError] = useState(errorTxt);    
    function classNames(...classes) {
      return classes.filter(Boolean).join(' ')
    }
    
    const onFocusEventHandler = (event) => {
        errorTxt = null;
        // return false;
        let fieldElement = event.target.parentElement.parentElement;
        fieldElement.classList.remove('error');
        let errorElement = document.getElementById("errorTxt_"+uid);
        if(errorElement) {
            
            errorElement.innerText = "";
        }
        hasError = false;
        return false;
    }

  return (
    <>
        <div id={uid} className={"fieldHolder fieldHolder m-0 "+(hasError ? "error" : "")+" col-span-"+props.colspan+" sm:col-span-"+props.smcolspan+" "+props?.className} onBlurCapture={(event) => onFocusEventHandler(event)}>
    <div className={props?.innerClass}>
                <label htmlFor={props.id} className="block text-sm font-medium leading-6 text-gray-900">
                  {label}
                  { required &&
                  <span className="required ">*</span>
                  }
                  {props?.help && props?.help != '' &&
        <>
<button ref={setTriggerRef} data-popover-target="popover-description" data-popover-placement="bottom-end" type="button"><svg className="inline w-4 h-4 ms-2 text-gray-400 hover:text-gray-500" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"></path></svg><span className="sr-only">Show information</span></button>
</>
                  
                  }
                </label>
                <div className={" "+props?.className}>
{visible && (
        <div
          ref={setTooltipRef}
          {...getTooltipProps({ className: 'tooltip-container' })}
        >
          <div {...getArrowProps({ className: 'tooltip-arrow' })} />
          <span className="text-sm text-gray-500" dangerouslySetInnerHTML={{ __html: props.help }} />
        </div>
      )}                
                    {props.children}
                </div>
                {hasError && errorTxt != "" && 
                <p id={'errorTxt_'+uid} className="error  mb-2 pl-2 text-xs text-red-600">{errorTxt}</p>
                }                
        </div>
        </div>
    </>
    );
}
/*
FieldHolder.defaultProps = {
    colspan: 12,
    smcolspan: 12,
    label: "Label",
    id: "Label",
    error: false
};
 */